var map = {
	"./social-500px.svg": 99,
	"./social-dribbble.svg": 100,
	"./social-facebook.svg": 101,
	"./social-github.svg": 102,
	"./social-google.svg": 103,
	"./social-instagram.svg": 104,
	"./social-odnoklassniki.svg": 105,
	"./social-rediit.svg": 106,
	"./social-stackoverflow.svg": 107,
	"./social-steam.svg": 108,
	"./social-twitch.svg": 109,
	"./social-twitter.svg": 110,
	"./social-vkontakte.svg": 111,
	"./social-windows.svg": 112,
	"./social-yahoo.svg": 113
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 98;


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/avatars ^\.\/social\-.*\.svg$
// module id = 98
// module chunks = 0